import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Shield } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
import { Countdown } from '../ui/Countdown';
export function FinalCTA() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-navy-primary py-12 md:py-20 px-4 md:px-6" data-id="element-104">
      <div className="max-w-3xl mx-auto text-center" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-106">
          <div className="space-y-4 md:space-y-5 text-white mb-8 md:mb-10" data-id="element-107">
            <p className="text-lg md:text-2xl leading-relaxed" data-id="element-108">
              Każdy tydzień bez systemu to kolejna niedziela przy laptopie.
            </p>
            <p className="text-lg md:text-2xl leading-relaxed" data-id="element-109">
              Kolejny trening bez planu.
            </p>
            <p className="text-lg md:text-2xl leading-relaxed" data-id="element-110">
              Kolejny rodzic bez odpowiedzi.
            </p>
            <p className="text-2xl md:text-4xl font-display font-bold pt-3" style={{
            color: '#F5A623'
          }} data-id="element-111">
              Masz teraz wybór.
            </p>
          </div>

          <div className="flex flex-col items-center gap-5" data-id="element-112">
            <CTAButton onClick={scrollToOffer} size="large" className="w-full sm:w-auto" data-id="element-113">
              ⚽ TAK! Chcę 40 tygodni gotowych planów — 73 ZŁ
            </CTAButton>

            <Countdown data-id="element-114" />

            <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-xs md:text-sm text-gray-300 mt-2" data-id="element-115">
              <span className="flex items-center gap-1" data-id="element-116">
                <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-accent" data-id="element-117" />
                Natychmiastowy dostęp
              </span>
              <span className="flex items-center gap-1" data-id="element-118">
                <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-accent" data-id="element-119" />
                Gwarancja 7 dni
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}